import LocalStorage from '../../data/local-storage';

export default class ProfileModel {
  constructor() {
    this.isAuthenticated = false;
    this.user = {};
    this.currentTheme = 'light';
    this.currentFont = 'default';
    this.pushSubscription = null;
    this.bookmarks = [];
    this.notifications = [];
  }

  loadUserState() {
    const token = LocalStorage.getItem('heliaedu_token');
    const userData = LocalStorage.getItem('heliaedu_user');
    
    if (token && userData) {
      this.isAuthenticated = true;
      this.user = JSON.parse(userData);
      
      const bookmarksKey = `heliaedu_user_bookmarks_${this.user.id}`;
      const notificationsKey = `heliaedu_user_notifications_${this.user.id}`;
      const pushSubscriptionKey = `heliaedu_user_push_subscription_${this.user.id}`;
      
      this.bookmarks = LocalStorage.getObject(bookmarksKey) || [];
      this.notifications = LocalStorage.getObject(notificationsKey) || [];
      this.pushSubscription = LocalStorage.getObject(pushSubscriptionKey);
    } else {
      this.isAuthenticated = false;
      this.user = {};
      this.bookmarks = [];
      this.notifications = [];
      this.pushSubscription = null;
    }

    this.currentTheme = LocalStorage.getItem('heliaedu_theme') || 'light';
    this.currentFont = LocalStorage.getItem('heliaedu_font') || 'default';
  }

  getUserData() {
    return {
      isAuthenticated: this.isAuthenticated,
      user: this.user,
      bookmarkCount: this.bookmarks.length,
      notificationCount: this.notifications.length
    };
  }

  updateTheme(theme) {
    this.currentTheme = theme;
    LocalStorage.setItem('heliaedu_theme', theme);
    return true;
  }

  updateFont(font) {
    this.currentFont = font;
    LocalStorage.setItem('heliaedu_font', font);
    return true;
  }

  getCurrentTheme() {
    return this.currentTheme;
  }

  getCurrentFont() {
    return this.currentFont;
  }

  isPushSubscribed() {
    return !!this.pushSubscription;
  }

  setPushSubscription(subscription) {
    this.pushSubscription = subscription;
    
    if (this.isAuthenticated && this.user.id) {
      const pushSubscriptionKey = `heliaedu_user_push_subscription_${this.user.id}`;
      if (subscription) {
        LocalStorage.setObject(pushSubscriptionKey, subscription);
      } else {
        LocalStorage.removeItem(pushSubscriptionKey);
      }
    }
  }

  logout() {
    LocalStorage.removeItem('heliaedu_token');
    LocalStorage.removeItem('heliaedu_user');
    
    this.isAuthenticated = false;
    this.user = {};
    this.bookmarks = [];
    this.notifications = [];
    this.pushSubscription = null;
    
    return true;
  }

  getProfileStats() {
    return {
      bookmarkCount: this.bookmarks.length,
      notificationCount: this.notifications.length,
      isPushSubscribed: this.isPushSubscribed()
    };
  }
}